import * as React from 'react';

const AlignCenter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.38462 1V4.6H5.07692V9.4H9.38462V10.6H2V15.4H9.38462V19H10.6154V15.4H18V10.6H10.6154V9.4H14.9231V4.6H10.6154V1H9.38462Z" fill="currentColor"/>
  </svg>
);

export default AlignCenter;
